import { lightColors } from "../../theme/colors";
export var light = {
    background: lightColors.backgroundAlt
};
export var dark = {
    background: "rgba(11, 61, 145, 0.8);"
};
